/**
 * AP-13 — Einstiegspunkt des Lizenz-Clients. `LicenseManager::Instance()`
 * des Originals; die App hält genau eine Instanz.
 */

import { LicenseManager } from './LicenseManager';

export { LicenseManager, LICENSE_SERVER_URL, OFFLINE_GRACE_DAYS, TRIAL_GRACE_MINUTES } from './LicenseManager';
export type { LicenseState, LicenseManagerOptions } from './LicenseManager';
export { createMemoryLicenseStorage, createIndexedDbLicenseStorage } from './storage';
export type { LicenseStorage } from './storage';

export const licenseManager = new LicenseManager();
